import React from 'react';
import { useTranslations } from '../../../../../../hooks/useTranslations';
import CheckMarkIcon from '../../../../../ui/icons/CheckMark/CheckMark';
import ControlView from '../../ControlView/ControlView';

interface CprefMarketingSubscribedProps {
  featureName?: string;
  isLandscape: boolean;
  narvarProfileUrl: string;
  onSignUpAgainClick: () => void;
}

const CprefMarketingSubscribed = ({
  featureName,
  isLandscape,
  narvarProfileUrl,
  onSignUpAgainClick,
}: CprefMarketingSubscribedProps) => {
  const {
    notificationCenterSublimeManageYourPreferences,
    notificationCenterSublimeAutoOptinTitle,
    notificationCenterSublimeAutoOptinText,
  } = useTranslations();

  // Temporary translations
  const notificationCenterSmsChangeMarketingOptin = 'Update Marketing Opt-in';

  const handlePrimaryButtonClick = () => {
    window.open(`${narvarProfileUrl}/login?type=phone`);
  };

  const handleSecondaryButtonClick = () => {
    onSignUpAgainClick();
  };

  return (
    <ControlView
      channel="sms"
      isLandscape={isLandscape}
      featureName={featureName}
      icon={<CheckMarkIcon />}
      heading={notificationCenterSublimeAutoOptinTitle ?? undefined}
      text={notificationCenterSublimeAutoOptinText ?? undefined}
      primaryButton={{
        text: notificationCenterSublimeManageYourPreferences ?? '',
        onClick: handlePrimaryButtonClick,
      }}
      secondaryButton={{
        text: notificationCenterSmsChangeMarketingOptin,
        onClick: handleSecondaryButtonClick,
      }}
    />
  );
};

export default CprefMarketingSubscribed;
